import React, { useState, useRef, useEffect, useContext } from "react";
import {
  MapContainer,
  TileLayer,
  LayersControl,
  useMap
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { GeoJSON } from "react-leaflet";
import { gisStateCoordinates, getResourceDetailsById, gisBlockCoordinatesData, gisPanchayatCoordinatesData } from "../../../../Services/EndPoints";

import { toast } from "react-toastify";
import { getData, postDataWithBody } from "../../../../Services/Services";
import Loader from "react-spinner-loader";
import { GoogleProvider } from 'leaflet-geosearch';
// Add leaflet-geosearch CSS
import 'leaflet-geosearch/dist/geosearch.css';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { Marker, Popup } from 'react-leaflet';
import { ThemeContext } from "../../../..";

// Fix for default marker icons in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

// Custom marker icon
const createCustomIcon = (color = 'blue') => {
  return new L.Icon({
    iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`,
    shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
};
// Custom search control component with improved styling
const SearchControl = (props) => {
  const map = useMap();

  useEffect(() => {
    (
      async () => {
        const response = await getData(gisBlockCoordinatesData);
        console.log("Map response", response)
      }
    )()
  }, [])


  useEffect(() => {
    const provider = new OpenStreetMapProvider();

    const searchControl = new GeoSearchControl({
      provider,
      style: 'bar',
      showMarker: true,
      showPopup: true,
      marker: {
        icon: new L.Icon({
          iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
        }),
        draggable: false,
      },
      popupFormat: ({ query, result }) => result.label,
      maxMarkers: 1,
      retainZoomLevel: false,
      animateZoom: true,
      autoClose: true,
      searchLabel: 'Enter location',
      keepResult: true,
      ...props,
    });

    map.addControl(searchControl);

    // Apply custom CSS to the search control
    const style = document.createElement('style');
    style.innerHTML = `
      .leaflet-control-geosearch input {
        width: 200px !important;
        font-size: 14px !important;
        color: #000 !important;
      }
      .leaflet-control-geosearch .results > * {
        color: #000 !important;
        font-size: 14px !important;
        padding: 8px 12px !important;
      }
      .leaflet-control-geosearch .results > *.active {
        background-color: #f8f9fa !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      map.removeControl(searchControl);
      document.head.removeChild(style);
    };
  }, [map, props]);

  return null;
};

const getShortenedText = (strLength, fulltext) => {
  let abbreviatedText = "";
  if (fulltext.length > strLength) {
    abbreviatedText = fulltext.substring(0, 25) + "...";
  } else {
    abbreviatedText = fulltext;
  }
  return <span title={fulltext}>{abbreviatedText}</span>;
};
// Toggle Button Component
const ToggleButton = ({ isMapView, onToggle }) => {
  const { theme } = useContext(ThemeContext);
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      backgroundColor:theme === "light" ? "#cfc9c9ff" : "#1f2a44",
      borderRadius: '25px',
      padding: '4px',
      margin: '0px 20px 20px 0px',
      width: 'fit-content'
    }}>
      <button
        onClick={() => onToggle(true)}
        style={{
          padding: '8px 16px',
          borderRadius: '20px',
          border: 'none',
          backgroundColor: isMapView ? '#007bff' : 'transparent',
          color: isMapView ? 'white' : 'white',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          fontWeight: isMapView ? 'bold' : 'normal'
        }}
      >
        Map
      </button>
      <button
        onClick={() => onToggle(false)}
        style={{
          padding: '8px 16px',
          borderRadius: '20px',
          border: 'none',
          backgroundColor: !isMapView ? '#007bff' : 'transparent',
          color: !isMapView ? 'white' : 'white',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          fontWeight: !isMapView ? 'bold' : 'normal'
        }}
      >
        Table
      </button>
    </div>
  );
};

// Basic Table Component
const DataTable = ({ resouceData }) => {
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    console.log("Resource Data in Table:", resouceData);
  }, [resouceData]);

  return (
    <div className="rd-table-container" style={{
      width: "100%",
     
      overflow: 'hidden',
      backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44",
      borderRadius: '8px',
      border: "1px solid #ddd",
      display: 'flex',
      flexDirection: 'column'
    }}>
      <div style={{
        overflow: 'auto',
        flex: 1
      }}>
        <table className="rd-table" style={{
          width: '100%',
          borderCollapse: 'collapse'
        }}>
          <thead style={{
            position: 'sticky',
            top: 0,
            zIndex: 1
          }}>
            <tr style={{ 
              backgroundColor: theme === "light" ? "#f8f9fa" : "#2c3e50" 
            }}>
              <th className="rd-table-th" style={{ 
                padding: '12px', 
                textAlign: 'left', 
                fontWeight: 'bold',
                borderBottom: '2px solid #ddd'
              }}>Resource Name</th>
              <th className="rd-table-th" style={{ 
                padding: '12px', 
                textAlign: 'left', 
                fontWeight: 'bold',
                borderBottom: '2px solid #ddd'
              }}>Region Name</th>
              <th className="rd-table-th" style={{ 
                padding: '12px', 
                textAlign: 'left', 
                fontWeight: 'bold',
                borderBottom: '2px solid #ddd'
              }}>Agency Name</th>
              <th className="rd-table-th" style={{ 
                padding: '12px', 
                textAlign: 'left', 
                fontWeight: 'bold',
                borderBottom: '2px solid #ddd'
              }}>Resource Facility Name</th>
              <th className="rd-table-th" style={{ 
                padding: '12px', 
                textAlign: 'left', 
                fontWeight: 'bold',
                borderBottom: '2px solid #ddd'
              }}>Agency Contact</th>
              <th className="rd-table-th" style={{ 
                padding: '12px', 
                textAlign: 'left', 
                fontWeight: 'bold',
                borderBottom: '2px solid #ddd'
              }}>Total Quantity</th>
              <th className="rd-table-th" style={{ 
                padding: '12px', 
                textAlign: 'left', 
                fontWeight: 'bold',
                borderBottom: '2px solid #ddd'
              }}>Damaged Quantity</th>
              <th className="rd-table-th" style={{ 
                padding: '12px', 
                textAlign: 'left', 
                fontWeight: 'bold',
                borderBottom: '2px solid #ddd'
              }}>Available Quantity</th>
              <th className="rd-table-th" style={{ 
                padding: '12px', 
                textAlign: 'left', 
                fontWeight: 'bold',
                borderBottom: '2px solid #ddd'
              }}>Resource Description</th>
            </tr>
          </thead>
          <tbody style={{ 
            backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44"
          }}>
            {resouceData && resouceData.map((resource) => {
              // Extract contact information
              const contact = resource.resource_contact_map?.[0]?.contact_details || {};
              const contactText = contact.phone1 ?
                `${contact.name || ''}${contact.name && contact.job_title_config?.value ? ', ' : ''}${contact.job_title_config?.value || ''}${(contact.name || contact.job_title_config?.value) ? ', ' : ''}${contact.phone1}` :
                resource.agency_details?.phone || '';
              const regionName = resource.resource_region_map?.[0]?.region_details?.name || '';
              
              return (
                <tr key={resource.id} style={{ 
                  borderBottom: '1px solid #ddd',
                  ':hover': {
                    backgroundColor: theme === "light" ? "#f5f5f5" : "#2a3b5a"
                  }
                }}>
                  <td className={theme === 'dark' ? "rd-table-td" : "rd-table-td1"} style={{ 
                    padding: '12px', 
                    whiteSpace: 'nowrap' 
                  }}>{resource.name}</td>
                  <td className={theme === 'dark' ? "rd-table-td" : "rd-table-td1"} style={{ 
                    padding: '12px', 
                    whiteSpace: 'nowrap' 
                  }}>{regionName}</td>
                  <td className={theme === 'dark' ? "rd-table-td" : "rd-table-td1"} style={{ 
                    padding: '12px', 
                    whiteSpace: 'nowrap' 
                  }}>{resource.agency_details?.name || ''}</td>
                  <td className={theme === 'dark' ? "rd-table-td" : "rd-table-td1"} style={{ 
                    padding: '12px', 
                    whiteSpace: 'nowrap' 
                  }}>{resource.facility_name || ''}</td>
                  <td className={theme === 'dark' ? "rd-table-td" : "rd-table-td1"} style={{ 
                    padding: '12px', 
                    whiteSpace: 'nowrap' 
                  }}>{contactText}</td>
                  <td className={theme === 'dark' ? "rd-table-td" : "rd-table-td1"} style={{ 
                    padding: '12px', 
                    whiteSpace: 'nowrap' 
                  }}>{resource.total_quantity || ''}</td>
                  <td className={theme === 'dark' ? "rd-table-td" : "rd-table-td1"} style={{ 
                    padding: '12px', 
                    whiteSpace: 'nowrap' 
                  }}>
                    {resource.damaged_quantity !== undefined && resource.damaged_quantity !== null ? 
                    resource.damaged_quantity : ''}
                  </td>
                  <td className={theme === 'dark' ? "rd-table-td" : "rd-table-td1"} style={{ 
                    padding: '12px', 
                    whiteSpace: 'nowrap' 
                  }}>
                    {resource.available_quantity !== undefined && resource.available_quantity !== null ? 
                      resource.available_quantity : ''}
                  </td>
                  <td className={theme === 'dark' ? "rd-table-td" : "rd-table-td1"} style={{ 
                    padding: '12px' 
                  }}>{getShortenedText(15, resource.description || '')}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const DeploymentResourceMap = ({ resouceData, shouldHighlight, incidentRegions }) => {
  const [loader, setLoader] = useState(false);
  const [stateGeoJSON, setStateGeoJSON] = useState(null);
  const [isMapView, setIsMapView] = useState(true);
  const mapRef = useRef(null);
  const [blockGeoJSON, setBlockGeoJSON] = useState(null);
  const [gisId, setGisId] = useState(null);
  const [panchayatGeoJSON, setPanchayatGeoJSON] = useState(null);
  const [showPanchayat, setShowPanchayat] = useState(false);
   const { theme } = useContext(ThemeContext);
  useEffect(() => {
    console.log("Map Resource Data:", resouceData);
    console.log("Incident Regions:", incidentRegions);

    // Only fetch panchayat coordinates when shouldHighlight is true (when Locate on Map is clicked)
    if (shouldHighlight && incidentRegions && incidentRegions.length > 0) {
      fetchAllPanchayatCoordinates(incidentRegions);
    }

    // Get gis_id from resource data for block
    if (shouldHighlight && resouceData && resouceData.length > 0) {
      const resource = resouceData[0];
      if (resource.facility_lat && resource.facility_lng && mapRef.current) {
        mapRef.current.flyTo([resource.facility_lat, resource.facility_lng], 15, {
          duration: 1,
          easeLinearity: 0.25
        });
      }

      const resourceGisId = resouceData[0].resource_region_map[0]?.region_details?.gis_id;
      if (resourceGisId) {
        fetchBlockCoordinates(resourceGisId);
      }
    }
  }, [shouldHighlight, resouceData, incidentRegions]);



  useEffect(() => {
    mapStateCoordinates();
  }, []);

  const fetchBlockCoordinates = async (gisId) => {
    try {
      const response = await getData(`${gisBlockCoordinatesData}${gisId}`);
      console.log("Block response", response);

      if (response && response.length > 0) {
        const blockData = response[0];
        const geoJsonData = {
          type: "Feature",
          properties: {
            state: blockData.st_name,
            district: blockData.dist_name,
            block: blockData.blk_name,
          },
          geometry: JSON.parse(blockData.coordinates),
        };
        setBlockGeoJSON(geoJsonData);

        if (mapRef.current) {
          const center = [
            blockData.latitude,
            blockData.longitude
          ];
          mapRef.current.setView(center, 10);
        }
      }
    } catch (error) {
      console.error("Error fetching Block coordinates:", error);
      toast.error("Failed to load Block coordinates");
    }
  };

  const fetchAllPanchayatCoordinates = async (incidentRegions) => {
    try {
      // Clear previous panchayat data
      setPanchayatGeoJSON(null);
      console.log("Fetching panchayat coordinates for regions:", incidentRegions);

      // Create an array to store all promises
      const promises = incidentRegions.map(async (region) => {
        if (region.gis_id) {
          const response = await getData(`${gisPanchayatCoordinatesData}${region.gis_id}`);
          if (response && response.length > 0) {
            // Combine panchayat coordinate data with incident region data
            return {
              ...response[0],
              incidentData: region // Include the incident region data
            };
          }
        }
        return null;
      });

      // Wait for all promises to resolve
      const results = await Promise.all(promises);

      // Filter out null results and create GeoJSON features
      const features = results.filter(Boolean).map((panchayatData) => ({
        type: "Feature",
        properties: {
          state: panchayatData.st_name,
          district: panchayatData.dist_name,
          block: panchayatData.blk_name,
          name: panchayatData.blk_name,
          // Include incident region data in properties
          incidentRegion: panchayatData.incidentData
        },
        geometry: JSON.parse(panchayatData.coordinates),
      }));

      // If we have features, set the state
      if (features.length > 0) {
        setPanchayatGeoJSON({
          type: "FeatureCollection",
          features: features
        });

        // Center the map on the first panchayat
        if (mapRef.current && results[0]) {
          const center = [
            results[0].latitude,
            results[0].longitude
          ];
          mapRef.current.setView(center, 12);
        }
      }
    } catch (error) {
      console.error("Error fetching Panchayat coordinates:", error);
      toast.error("Failed to load Panchayat coordinates");
    }
  };


  const mapStateCoordinates = async () => {
    setLoader(true);
    try {
      const res = await getData(gisStateCoordinates + 52); // Assuming 52 is Bihar's state_id

      if (res && res.length > 0) {
        const stateData = res[0];
        const geoJsonData = {
          type: "Feature",
          properties: {
            name: stateData.state_name,
            state_id: stateData.state_id,
          },
          geometry: JSON.parse(stateData.coordinates),
        };
        setStateGeoJSON(geoJsonData);
      }
    } catch (error) {
      console.error("Error fetching state coordinates:", error);
      toast.error("Failed to load state coordinates");
    } finally {
      setLoader(false);
    }
  };

  // Default center for Bihar
  const getMapCenter = () => {
    return [25.5941, 85.1376];
  };

  const handleToggle = (showMap) => {
    setIsMapView(showMap);
  };

  return (
    <>
      <div>
        <ToggleButton isMapView={isMapView} onToggle={handleToggle} />
      </div>
      <div style={{
        height: "424px", // Fixed height instead of 100vh
        fontFamily: "Arial, sans-serif",
        position: "relative" // Changed from sticky to relative
      }}>
        {loader && (
          <Loader
            show={loader}
            type="body"
            stack="vertical"
            message="Loading Data"
          />
        )}

        {isMapView ? (
          <div style={{ flex: 1 }}>
            <MapContainer
              ref={mapRef}
              center={getMapCenter()}
              attributionControl={false}
              zoom={7}
              style={{
                width: "100%",
                height: "424px",
              }}
              whenCreated={(mapInstance) => {
                mapRef.current = mapInstance;

              }}
            >
              <LayersControl position="topright" collapsed={false}>
                <LayersControl.BaseLayer name="Road View">
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                </LayersControl.BaseLayer>

                <LayersControl.BaseLayer name="Satellite View">
                  <TileLayer
                    attribution=""
                    url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                    maxZoom={20}
                    subdomains={["mt0", "mt1", "mt2", "mt3"]}
                  />
                </LayersControl.BaseLayer>

                <LayersControl.BaseLayer checked name="Terrain View">
                  <TileLayer
                    attribution=""
                    url="https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
                    maxZoom={20}
                    subdomains={["mt0", "mt1", "mt2", "mt3"]}
                  />
                </LayersControl.BaseLayer>

                <LayersControl.BaseLayer name="Hybrid View">
                  <TileLayer
                    attribution=""
                    url="https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
                    maxZoom={20}
                    subdomains={["mt0", "mt1", "mt2", "mt3"]}
                  />
                </LayersControl.BaseLayer>
              </LayersControl>

              <SearchControl
                position="topleft"
                autoComplete={true}
                autoCompleteDelay={250}
              />

              {/* State Border */}
              {stateGeoJSON && (
                <GeoJSON
                  key="state-boundary"
                  data={stateGeoJSON}
                  style={{
                    color: "#000000",
                    weight: 2,
                    fillColor: "transparent",
                    fillOpacity: 0.2,
                  }}
                  onEachFeature={(feature, layer) => {
                    if (feature.properties && feature.properties.name) {
                      layer.bindPopup(`State: ${feature.properties.name}`);
                    }
                  }}
                />
              )}
              {panchayatGeoJSON && (
                <GeoJSON
                  key="panchayat-boundary"
                  data={panchayatGeoJSON}
                  style={(feature) => {
                    // Dynamic styling based on incident status
                    const incidentData = feature.properties.incidentRegion;
                    const isAffected = incidentData?.code === "INCIDENT_REGION_AFFECT";
                    const isWarning = incidentData?.code === "INCIDENT_REGION_WARN";

                    return {
                      color: isAffected ? "#dc3545" : isWarning ? "#ffc107" : "#28a745",
                      weight: 3,
                      fillColor: isAffected ? "#f8d7da" : isWarning ? "#fff3cd" : "#d4edda",
                      fillOpacity: 0.6,

                    };
                  }}
                  onEachFeature={(feature, layer) => {
                    if (feature.properties) {
                      const props = feature.properties;
                      const incidentData = props.incidentRegion;

                      // Get status color and text
                      const getStatusInfo = (code) => {
                        switch (code) {
                          case "INCIDENT_REGION_AFFECT":
                            return { color: "#dc3545", text: "Affected", bgColor: "#f8d7da" };
                          case "INCIDENT_REGION_WARN":
                            return { color: "#ffc107", text: "Warning", bgColor: "#fff3cd" };
                          default:
                            return { color: "#28a745", text: "Normal", bgColor: "#d4edda" };
                        }
                      };

                      const statusInfo = getStatusInfo(incidentData?.code);

                      const popupContent = `
          <div style="font-family: Poppins; max-width: 300px;">
            <h6 style="margin: 0 0 10px 0; padding: 8px; background: ${statusInfo.color}; color: white; text-align: center; font-size: 14px; border-radius: 4px;">
              Panchayat Region - ${statusInfo.text}
            </h6>
            
            <!-- Geographic Information with enhanced styling -->
            <div style="padding: 5px; margin-bottom: 10px; background: ${statusInfo.bgColor}; border-radius: 4px; border-left: 4px solid ${statusInfo.color};">
              
              <div style="display: flex; margin-bottom: 3px;">
                <span style="font-weight: bold; flex: 1.5; color: #6c757d;">District:</span>
                <span style="flex: 2; color: #495057;">${props.district || 'NA'}</span>
              </div>
              <div style="display: flex; margin-bottom: 3px;">
                <span style="font-weight: bold; flex: 1.5; color: #6c757d;">Block:</span>
                <span style="flex: 2; color: #495057;">${props.block || 'NA'}</span>
              </div>
              <div style="display: flex; margin-bottom: 3px;">
                <span style="font-weight: bold; flex: 1.5; color: #6c757d;">Panchayat:</span>
                <span style="flex: 2; color: #495057;">${props.incidentRegion.name || 'NA'}</span>
              </div>
            </div>
        
          </div>
        `;

                      layer.bindPopup(popupContent, {
                        maxWidth: 320,
                        className: 'custom-popup'
                      });
                    }
                  }}
                />
              )}
              {/* Block Boundary */}
              {blockGeoJSON && (
                <GeoJSON
                  key="Block-boundary"
                  data={blockGeoJSON}
                  style={{
                    color: "#1a5cb8",
                    weight: 3,
                    fillColor: "#3388ff",
                    fillOpacity: 0.3,
                  }}
                  onEachFeature={(feature, layer) => {
                    if (feature.properties) {
                      const popupContent = `
          <div style="font-family: Poppins; max-width: 250px;">
            <h6 style="margin: 0 0 10px 0; padding: 5px; background: #1a5cb8; color: white; text-align: center; font-size: 14px;">Incident Region</h6>
            <div style="padding: 5px; margin-bottom: 10px; background: #e3f2fd; border-radius: 4px; border-left: 4px solid #1976d2;">
              
              <div style="display: flex; margin-bottom: 5px;">
                <span style="font-weight: bold; flex: 1; color: #7f8c8d;">District:</span>
                <span style="flex: 2; color: #495057;">${feature.properties.district || 'NA'}</span>
              </div>
              <div style="display: flex;">
                <span style="font-weight: bold; flex: 1; color: #7f8c8d;">Block:</span>
                <span style="flex: 2; color: #495057;">${feature.properties.block || 'NA'}</span>
              </div>
            </div>
          </div>
        `;
                      layer.bindPopup(popupContent);
                    }
                  }}
                />
              )}



              {shouldHighlight && resouceData && resouceData.length > 0 && resouceData.map((resource) => {
                if (resource.facility_lat && resource.facility_lng) {
                  return (
                    <Marker
                      key={resource.id}
                      position={[resource.facility_lat, resource.facility_lng]}
                      icon={createCustomIcon('red')}
                    >
                      <Popup>
                        <div style={{
                          height: "350px",
                          overflow: "auto",
                          maxWidth: '300px',
                          fontFamily: 'Poppins'
                        }}>
                          {/* Resource Section */}
                          <div style={{
                            padding: '10px',
                            borderBottom: '2px solid #e0e0e0',
                            marginBottom: '10px',
                            background: '#e3f2fd',
                            borderRadius: '4px',
                            borderLeft: '4px solid #1976d2'
                          }}>
                            <h4 style={{
                              margin: '0 0 10px 0',
                              color: '#495057',
                              fontSize: '14px',
                              fontWeight: 'bold'
                            }}>Resource Details</h4>
                            <div style={{ marginBottom: '5px' }}>
                              <strong style={{ color: '#7f8c8d' }}>Resource:</strong>
                              <span style={{ marginLeft: '5px' }}>{resource.name}</span>
                            </div>
                            <div style={{ marginBottom: '5px' }}>
                              <strong style={{ color: '#7f8c8d' }}>Category:</strong>
                              <span style={{ marginLeft: '5px' }}>{resource.rsrc_cat_id}</span>
                            </div>

                            <div style={{ marginBottom: '5px' }}>
                              <strong style={{ color: '#7f8c8d' }}>Activity:</strong>
                              <span style={{ marginLeft: '5px' }}>{resource.rsrc_activity_id}</span>
                            </div>

                            <div style={{ marginBottom: '5px' }}>
                              <strong style={{ color: '#7f8c8d' }}>Description:</strong>
                              <span style={{ marginLeft: '5px' }}>{resource.description || 'NA'}</span>
                            </div>

                            <div style={{
                              // display: 'flex',
                              justifyContent: 'space-between',
                              marginTop: '10px'
                            }}>
                              <div>
                                <strong style={{ color: '#7f8c8d' }}>Total Quantity:</strong>
                                <span style={{ marginLeft: '5px' }}>{resource.total_quantity}</span>
                              </div>
                              <div>
                                <strong style={{ color: '#7f8c8d' }}>Damaged Quantity:</strong>
                                <span style={{ marginLeft: '5px', color: '#FF0000' }}>{resource.damaged_quantity || 0}</span>
                              </div>
                              <div>
                                <strong style={{ color: '#7f8c8d' }}>Available Quantity:</strong>
                                <span style={{ marginLeft: '5px', color: resource.available_quantity > 0 ? '#27ae60' : '#e74c3c' }}>
                                  {resource.available_quantity}
                                </span>
                              </div>
                              {/* <div>
                                <strong style={{ color: '#7f8c8d' }}>Deployed Quantity:</strong>
                                <span style={{ marginLeft: '5px' }}>{resource.deploy_quantity || 0}</span>
                              </div> */}
                            </div>

                            {/* Contacts Section */}
                            {resource.resource_contact_map?.length > 0 && (
                              <div style={{ padding: '10px 0px 0px 0px' }}>
                                {/* <h4 style={{
                                margin: '0 0 8px 0',
                                color: '#2c3e50',
                                fontSize: '16px'
                              }}>Contacts</h4> */}
                              </div>
                            )}
                          </div>
                          {/* Agency Section */}
                          <div style={{
                            padding: '10px',
                            borderBottom: resource.resource_contact_map?.length ? '2px solid #e0e0e0' : 'none',
                            marginBottom: resource.resource_contact_map?.length ? '10px' : '0',
                            background: '#e3f2fd',
                            borderRadius: '4px',
                            borderLeft: '4px solid #1976d2'
                          }}>
                            <h4 style={{
                              margin: '0 0 10px 0',
                              color: '#495057',
                              fontSize: '14px',
                              fontWeight: 'bold'
                            }}>Agency Details</h4>

                            <div style={{ marginBottom: '5px' }}>
                              <strong style={{ color: '#7f8c8d' }}>Agency Name:</strong>
                              <span style={{ marginLeft: '5px' }}>{resource.agency_details?.name || 'NA'}</span>
                            </div>

                            {resource.resource_contact_map.map((contactMap, index) => {
                              const contact = contactMap.contact_details;
                              return (
                                <div key={index} style={{
                                  marginBottom: '10px',
                                  padding: '8px',
                                  backgroundColor: '#f8f9fa',
                                  borderRadius: '4px'
                                }}>
                                  <div style={{ marginBottom: '3px' }}>
                                    <strong style={{ color: '#7f8c8d' }}>Name:</strong>
                                    <span style={{ marginLeft: '5px' }}>{contact.name || 'NA'}</span>
                                  </div>

                                  {contact.job_title_config?.value && (
                                    <div style={{ marginBottom: '3px' }}>
                                      <strong style={{ color: '#7f8c8d' }}>Job Title:</strong>
                                      <span style={{ marginLeft: '5px' }}>{contact.job_title_config.value}</span>
                                    </div>
                                  )}

                                  <div style={{ marginBottom: '3px' }}>
                                    <strong style={{ color: '#7f8c8d' }}>Phone:</strong>
                                    <span style={{ marginLeft: '5px' }}>{contact.phone1 || 'NA'}</span>
                                  </div>


                                </div>
                              );
                            })}

                          </div>
                          {/* Facility Section */}
                          <div style={{
                            padding: '10px',
                            borderBottom: '2px solid #e0e0e0',
                            marginBottom: '10px',
                            background: '#e3f2fd',
                            borderRadius: '4px',
                            borderLeft: '4px solid #1976d2'
                          }}>
                            <h4 style={{
                              margin: '0 0 10px 0',
                              color: '#495057',
                              fontSize: '14px',
                              fontWeight: 'bold'
                            }}>Facility Details</h4>

                            <div style={{ marginBottom: '5px' }}>
                              <strong style={{ color: '#7f8c8d' }}>Name:</strong>
                              <span style={{ marginLeft: '5px' }}>{resource.facility_name || 'NA'}</span>
                            </div>

                            <div style={{ marginBottom: '5px' }}>
                              <strong style={{ color: '#7f8c8d' }}>Address:</strong>
                              <span style={{ marginLeft: '5px' }}>{resource.facility_address || 'NA'}</span>
                            </div>

                            {/* <div style={{ marginBottom: '5px' }}>
                              <strong style={{ color: '#7f8c8d' }}>Coordinates:</strong>
                              <span style={{ marginLeft: '5px' }}>
                                {resource.facility_lat?.toFixed(6)}, {resource.facility_lng?.toFixed(6)}
                              </span>
                            </div> */}

                            {/* Add Facility Contact Details */}
                            {resource.facility_contact_details?.length > 0 && (
                              <div style={{
                                marginTop: '10px',
                                padding: '8px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px'
                              }}>
                                {/* <h5 style={{
        margin: '0 0 5px 0',
        color: '#2c3e50',
        fontSize: '13px'
      }}>Facility Contact:</h5> */}

                                {resource.facility_contact_details.map((contact, index) => (
                                  <div key={index}>
                                    <div style={{ marginBottom: '3px' }}>
                                      <strong style={{ color: '#7f8c8d' }}>Name:</strong>
                                      <span style={{ marginLeft: '5px' }}>{contact.name || 'NA'}</span>
                                    </div>
                                    <div style={{ marginBottom: '3px' }}>
                                      <strong style={{ color: '#7f8c8d' }}>Phone:</strong>
                                      <span style={{ marginLeft: '5px' }}>{contact.phone1 || 'NA'}</span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </Popup>
                    </Marker>
                  );
                }
                return null;
              })}
            </MapContainer>
          </div>
        ) : (
          <div style={{ flex: 1 }}>
            <DataTable resouceData={resouceData} />
          </div>
        )}
      </div>
    </>
  );
};

export default DeploymentResourceMap;